import primaryComponents from "../../../primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import styles from "./styles.module.scss";
import { DesignDivider } from "../../../common";
import { useValidation } from "./useValidation";
import { useGoalsForm } from "./useGoalsForm";
import { StarIcon } from "../../../../assets/svgIcons";

export const GoalsForm = ({
  isEditMode = false,
  goalDetails = {},
  closeModal = () => {},
}) => {
  const {
    isCreatingGoals,
    storeList,
    goalsForm,
    setGoalsForm,
    handleCreateOrUpdateGoals,
  } = useGoalsForm({ goalDetails, isEditMode, closeModal });
  const {
    register,
    control,
    trigger,
    formState: { errors },
    handleSubmit,
  } = useValidation({ ...goalsForm });

  return (
    <>
      <form
        className={`${globalStyles.pageColumnGaps}`}
        style={{ gap: "5px" }}
        id="goalsForm"
        onSubmit={handleSubmit(handleCreateOrUpdateGoals)}
      >
        <primaryComponents.InputFieldV2
          control={control}
          register={register}
          name="name"
          label={"Goals Name"}
          placeholder={"Enter goal name"}
          classNames="white"
          isRequired
          value={goalsForm?.name}
          errorMessage={errors?.name}
          onKeyUp={() => errors?.name && trigger("name")}
          onChange={({ target: { value } }) => {
            setGoalsForm((prevState) => ({
              ...prevState,
              name: value,
            }));
          }}
        />

        <primaryComponents.MultipleSelectFieldV2
          control={control}
          name="store_ids"
          label={"Store"}
          isRequired
          options={storeList}
          idKey="id"
          nameKey="name"
          value={goalsForm?.store_ids?.map((id) => {
            const store = storeList?.find(
              (store) => `${store?.id}` === `${id}`,
            );

            return {
              label: store?.name,
              value: store?.id,
            };
          })}
          errorMessage={errors?.store_ids}
          onChange={(values) => {
            setGoalsForm((prevState) => ({
              ...prevState,
              store_ids: values?.map((val) => val?.value),
            }));
          }}
        />

        <div
          className={`${globalStyles.cardWithBorder} card-plain px-3 pt-2 pb-3 mb-3`}
        >
          <div>
            <label>
              <span className="error--text">*</span>Goal Category
            </label>
            <p className="small-text-size">
              Select a category this goal falls into
            </p>
          </div>

          <div
            className={`${globalStyles.cardWithBorder} p-3 white flex-md-row`}
            style={{ columnGap: "20px" }}
          >
            <primaryComponents.BoxedRadioInput
              name={"goalsType"}
              classNames="align-items-start"
              style={{ minHeight: "75px", height: "auto" }}
              isChecked={goalsForm?.type === "grossRevenue"}
              isControlled={true}
            >
              <span className="mt-1 d-block">
                <span className="d-flex mb-1">Gross Revenue Goal</span>

                <span className="gray--text smallest-text-size">
                  This is the total income you aim to meet before the deduction
                  of returns, discounts, allowances & cost of goods sold.
                </span>
              </span>
            </primaryComponents.BoxedRadioInput>
            <primaryComponents.BoxedRadioInput
              name={"goalsType"}
              classNames="align-items-start"
              style={{ minHeight: "75px", height: "auto" }}
              isDisabled={true}
              isControlled={true}
            >
              <span className="mt-1 d-block">
                <span className="d-flex justify-content-between align-items-start mb-1">
                  <span className="gray--text">Net Revenue Goal</span>

                  <span
                    className={`d-flex align-items-center ${globalStyles["statusBlock--purple"]}`}
                    style={{ marginTop: "-10px" }}
                  >
                    Coming Soon
                    <StarIcon className="ml-2" />
                  </span>
                </span>
                <span className="gray--text smallest-text-size">
                  This is the total profit you aim to meet after the deduction
                  of returns, discounts, allowances & cost of goods sold.
                </span>
              </span>
            </primaryComponents.BoxedRadioInput>
          </div>
        </div>

        <div
          className={`${globalStyles.cardWithBorder} flex-md-row align-items-md-center px-3 py-2 mb-3`}
          style={{ columnGap: "20px" }}
        >
          <primaryComponents.AmountFieldV2
            control={control}
            register={register}
            name="target_amount"
            label={"Target Amount for Your Goal"}
            placeholder="Enter amount"
            classNames="white"
            isRequired
            value={goalsForm?.target_amount}
            currency_code={
              storeList?.find(
                (store) => `${store?.id}` === `${goalsForm?.store_id}`,
              )?.currency_code
            }
            errorMessage={errors?.target_amount}
            onKeyUp={() => errors?.target_amount && trigger("target_amount")}
            onChange={({ target: { value } }) => {
              setGoalsForm((prevState) => ({
                ...prevState,
                target_amount: value,
              }));
            }}
          />

          <DesignDivider type="dashed" />

          <div style={{ width: "100%", maxWidth: "380px" }}>
            <div
              className={`${globalStyles.cardWithBorder} flex-row align-items-center mb-2 py-1`}
              style={{ columnGap: "10px", borderRadius: "20px" }}
            >
              <p className="small-text-size dark--text">
                Include Refunds In Calculations:
              </p>

              <span className="d-flex" style={{ gap: "10px" }}>
                <primaryComponents.RadioButton
                  name={"includeRefundOnGoal"}
                  id={"includeRefundOnGoalYes"}
                  isControlled={true}
                  checked={goalsForm?.include_refund_in_calc}
                  setRadioValue={() =>
                    setGoalsForm((prev) => ({
                      ...prev,
                      include_refund_in_calc: true,
                    }))
                  }
                >
                  Yes
                </primaryComponents.RadioButton>
                <DesignDivider height="25px" />
                <primaryComponents.RadioButton
                  name={"includeRefundOnGoal"}
                  id="includeRefundOnGoalNo"
                  isControlled={true}
                  checked={!goalsForm?.include_refund_in_calc}
                  setRadioValue={() =>
                    setGoalsForm((prev) => ({
                      ...prev,
                      include_refund_in_calc: false,
                    }))
                  }
                >
                  No
                </primaryComponents.RadioButton>
              </span>
            </div>

            <p className="smallest-text-size">
              Refunds will be subtracted from revenue
            </p>
          </div>
        </div>

        <div
          className={`${globalStyles.cardWithBorder} flex-md-row px-3 py-2 mb-3`}
          style={{ columnGap: "20px" }}
        >
          <primaryComponents.DateInputV2
            control={control}
            register={register}
            name="start_date"
            label={"Start Date"}
            classNames="white"
            isRequired
            value={goalsForm?.start_date}
            errorMessage={errors?.start_date}
            onKeyUp={() => errors?.start_date && trigger("start_date")}
            onChange={({ target: { value } }) => {
              setGoalsForm((prevState) => ({
                ...prevState,
                start_date: value,
              }));
            }}
          />
          <primaryComponents.DateInputV2
            control={control}
            register={register}
            name="end_date"
            label={"End Date"}
            classNames="white"
            isRequired
            value={goalsForm?.end_date}
            errorMessage={errors?.end_date}
            onKeyUp={() => errors?.end_date && trigger("end_date")}
            onChange={({ target: { value } }) => {
              setGoalsForm((prevState) => ({
                ...prevState,
                end_date: value,
              }));
            }}
          />
        </div>

        <primaryComponents.TextAreaV2
          control={control}
          register={register}
          name="notes"
          label={"Notes"}
          placeholder={"Type reason"}
          classNames="white"
          value={goalsForm?.notes}
          onChange={({ target: { value } }) => {
            setGoalsForm((prevState) => ({
              ...prevState,
              notes: value,
            }));
          }}
        />
      </form>

      <div
        className={`${globalStyles.stickyBottomCover} ${styles.stickyBottomCover}`}
      >
        <primaryComponents.Button
          classNames={"btn btn--primary cover"}
          type="submit"
          form="goalsForm"
          isDisabled={isCreatingGoals}
          isLoading={isCreatingGoals}
          loadingText={isEditMode ? "Updating..." : "Creating..."}
        >
          {isEditMode ? "Update Goal" : "Start Goal"}
        </primaryComponents.Button>
      </div>
    </>
  );
};
